/**
 * Shared sx blocks for the Bed / Bed Type Management grids and modals.
 * Lifted verbatim from UserDetails so the two new screens read the same as the
 * User and Doctor Management lists they sit next to.
 */

export const dataGridSx = {
  "& .MuiDataGrid-root": {
    border: "1px solid #e0e0e0",
    borderRadius: "4px",
    fontFamily: "Arial, sans-serif",
    padding: "5px",
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#125386",
    color: "white",
    fontSize: "13px",
    fontWeight: "600",
    minHeight: "48px !important",
    "& .MuiDataGrid-columnHeaderTitle": {
      color: "white",
      fontWeight: "600",
      fontSize: "13px",
    },
    "& .MuiDataGrid-columnHeader": {
      borderRight: "1px solid rgba(255, 255, 255, 0.3)",
      padding: "0 12px",
    },
    "& .MuiDataGrid-columnHeader:last-child": {
      borderRight: "none",
    },
    "& .MuiDataGrid-iconButtonContainer": { color: "white" },
    "& .MuiDataGrid-menuIcon": { color: "white" },
    "& .MuiDataGrid-sortIcon": { color: "white" },
    "& .MuiSvgIcon-root": { color: "white" },
  },
  "& .MuiDataGrid-row": {
    backgroundColor: "white",
    minHeight: "40px !important",
    "&:hover": { backgroundColor: "#f8f9fa" },
    "&.Mui-selected": {
      backgroundColor: "#e3f2fd",
      "&:hover": { backgroundColor: "#e3f2fd" },
    },
    borderBottom: "1px solid #e0e0e0",
  },
  "& .MuiDataGrid-cell": {
    borderRight: "1px solid #e0e0e0",
    fontSize: "12px",
    color: "#374151",
    padding: "8px 12px",
    minHeight: "40px !important",
    "&:last-child": { borderRight: "none" },
    "&:focus": { outline: "none" },
  },
  "& .MuiDataGrid-footerContainer": {
    backgroundColor: "#f8f9fa",
    borderTop: "1px solid #e0e0e0",
    minHeight: "52px",
  },
  "& .MuiTablePagination-root": { color: "#374151", fontSize: "12px" },
  "& .MuiDataGrid-toolbarContainer": {
    backgroundColor: "#f8f9fa",
    borderBottom: "1px solid #e0e0e0",
    padding: "8px 16px",
  },
};

export const modalBoxSx = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "white",
  border: "2px solid #000",
  borderRadius: "8px",
  padding: { xs: "16px", sm: "20px" },
  boxShadow: "5px 5px 15px rgba(0, 0, 0, 0.5)",
  width: { xs: "98%", sm: "85%", md: "70%", lg: "60%" },
  maxWidth: "700px",
  maxHeight: "90vh",
  overflowY: "auto",
};

export const cancelButtonSx = {
  backgroundColor: "#FFBD8A",
  padding: "8px 14px",
  border: "1px solid #FF8D28",
  borderRadius: "10px",
  color: "#000000",
  boxShadow:
    "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
  "&:hover": {
    backgroundColor: "#FFBD8A",
    border: "1px solid #FF8D28",
  },
  flex: "1",
  minWidth: 0,
};

export const confirmButtonSx = {
  backgroundColor: "#A1DA3B",
  padding: "8px 14px",
  border: "1px solid #8DC63F",
  borderRadius: "10px",
  color: "#000000",
  boxShadow:
    "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
  "&:hover": {
    backgroundColor: "#A1DA3B",
    border: "1px solid #8DC63F",
  },
  flex: "1",
  minWidth: 0,
};
